import React, { useState } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components";

import Alert from "components/atoms/alert/Alert";
import RadioButton from "components/atoms/input/RadioButton";
import useLoading from "components/atoms/loading/useLoading";
import useToast from "components/atoms/toast/useToast";

import FormInput from "components/molecules/FormInput";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { useSpaceMemberInvite } from "hooks/queries/useUser";

import Constants from "utils/constants";

const Container = styled.div`
    width: 100%;
`;

const RoleBoxLabel = styled.div`
    margin-bottom: 4px;
    font-size: 1.2rem;
    font-weight: 500;
    color: var(--color-Black);
`;

const RoleOptionList = styled.div`
    display: flex;
    gap: 8px;
`;

function SpaceMemberInviteModal(props) {
    const { space_uuid } = useParams();

    const { setLoading } = useLoading();
    const { setToast } = useToast();

    const [email, setEmail] = useState("");
    const filteredRoleData = Constants.SPACE_MEMBER_ROLES.filter(
        (role) => role.id !== Constants.SPACE_MEMBER_ROLE_ADMIN,
    );
    const [selectedRole, setSelectedRole] = useState(Constants.SPACE_MEMBER_ROLE_EDITOR);

    const spaceMemberInviteMutation = useSpaceMemberInvite();

    const handleInvite = async () => {
        if (email.length < 1) {
            Alert("warn", "에러", "이메일을 입력해주세요.");
            return;
        }

        try {
            setLoading(true);
            await spaceMemberInviteMutation.mutateAsync({
                space_uuid,
                data: {
                    email,
                    role: selectedRole,
                },
            });
            setToast("새로운 멤버를 초대했습니다.", "info");
            props.exitModal();
        } catch (error) {
            Alert("warn", "에러", error.response?.data?.error || "서버에 오류가 발생하였습니다.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <FormInput
                label="이메일"
                margin="0 0 16px 0"
                placeholder="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <RoleBoxLabel>역할</RoleBoxLabel>
            <RoleOptionList>
                {(filteredRoleData || []).map((role) => (
                    <RadioButton
                        key={role.id}
                        name="spaceMemberRole"
                        checked={selectedRole === role.id}
                        onChange={() => {
                            setSelectedRole(role.id);
                        }}
                        label={role.name}
                    />
                ))}
            </RoleOptionList>

            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"초대"}
                leftOnClick={props.exitModal}
                rightOnClick={() => {
                    handleInvite();
                }}
            />
        </Container>
    );
}

export default SpaceMemberInviteModal;
